// i18next.language can be a region-qualified tag (e.g. "en-US"); the backend
// only knows bare language codes.
const toLocale = (language: string) => language?.split('-')[0]

// Picks the best available translation for the current UI language: the
// exact language, then English, then whatever locale happens to be set, then ''.
export const pickLocalizedText = (
  value: Partial<Record<string, string>> | undefined,
  language: string
): string => {
  if (!value) return ''
  const locale = toLocale(language)
  return value[locale] || value.en || Object.values(value)[0] || ''
}
